import React from 'react';
import { makeStyles } from '@material-ui/core';

// eslint-disable-next-line no-unused-vars
const useStyles = makeStyles((theme) => ({
  footer: {
    marginTop: 100,
    position: 'absolute',
    bottom: 0,
    width: '100%',
    color: theme.palette.common.grey,
    textAlign: 'center',
    padding: theme.spacing(1),
    fontSize: 10,
    '& a': {
      textDecoration: 'none',
      color: theme.palette.primary.main,
    },
    '& a:hover': {
      color: theme.palette.primary.main,
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: 12,
      color: theme.palette.grey.dark,
      '& a': {
        textDecoration: 'none',
        color: theme.palette.common.grey,
      },
      '& a:hover': {
        color: theme.palette.primary.main,
      },
    },
  },
}));

const Footer = () => {
  const classes = useStyles();
  const year = new Date().getFullYear();

  return (
    <footer className={classes.footer}>
      {/* eslint-disable-next-line max-len */}
      &copy; Copyright {year}.{' '}
      <a href="https://www.shift.com.au/" target="_blank" rel="noopener noreferrer">
        Shift Financial
      </a>{' '}
      ABN: 24 149 390 625
    </footer>
  );
};

export default Footer;
